import { Rxios } from 'rxios'
import axios from 'axios'

export const rxios = new Rxios({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/crm`,
  withCredentials: true,
})

const { authToken } = JSON.parse(<string>sessionStorage.getItem('__LSM__') ?? '1')
export const restCommon = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/crm`,
  withCredentials: true,
  headers: {
    Authorization: `Bearer ${authToken}`,
  },
})
